// constant.jsx

// const base_urls = "https://pstgs.appsndevs.com/chatrap/";
const base_urls = "https://api.imagnce.com/chatrap/";

// const base_url = "https://pstgs.appsndevs.com/chatrap"; 
const base_url = "https://api.imagnce.com/chatrap";

// const BASE_URL = "https://pstgs.appsndevs.com/chatrap"; 
const BASE_URL = "https://api.imagnce.com/";

export { base_urls, base_url, BASE_URL };